/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.SecurityRoles {
    "use strict";

    export class SecurityRolesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        public loadedUserList: any = [];
        public copyFromSecurityRoleDetail: Model.DataDetail;
        public employeeCategoryDetail: Model.DataDetail;
        public canAssingSecurityRole: any = {};
        public smartCenterCriteria: any = {};

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            protected $http: angular.IHttpService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);
            this.showAllBusinesType = true;
        }

        initializeContext(): void {
            this.baseEndpoint = this.appSettings.API_ENDPOINTS.securityRole;
            this.sectionTemplatePath = "app/plugins/securityRoles/sectionViews/";
            this.buildCrudSecurityKeys(this.securityKeys.MANAGEMENT_SECURITYROLE_TAB_MAIN);
            this.entityType = 'SecurityRole';
        }

        initializeSections(): void {
            this.initializeContext();
           if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_SECURITYROLE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
               this.sections.push(new MainSection(0, "SECTION_SERVICES_MAIN", "main.html", true, false, this.appSettings.API_ENDPOINTS.securityRole,
                   "", this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.SecurityRoleMain, this.appSettings,
                   this.securityKeys.MANAGEMENT_SECURITYROLE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ, this.modalService));
           }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
            this.loadedUserList = Meevo.Model.Guard.isSomething(model.users) ? _.toArray(model.users) : [];
            this.loadAvailableUsers();
        }

        loadAvailableUsers(): void {
            // collect options for request criteria
            let usersOnly = Model.Guard.isSomething(this.employeeCategoryDetail) && this.employeeCategoryDetail.displayName === 'Users Only';
            let empCatId = Model.Guard.isSomething(this.employeeCategoryDetail) && this.employeeCategoryDetail.displayName !== 'Users Only' ? this.employeeCategoryDetail.id : null;
            let params: any = {
                usersOnly: usersOnly,
                employeeCategoryId: empCatId
            };
            this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/${this.baseEndpoint}/AvailableUsers/List`, 'POST',
                    {
                        asLocationId: this.selectedSection.model.locationId,
                        criteria: params,
                        itemsPerPage: 10000,
                        pageNumber: 0
                    })
                .then(response => {
                    let role = this.castModel<Model.SecurityRole>();
                    if (Model.Guard.isNothing(role))
                        return;
                    // filter available users and reset category filter
                    role.availableUsers = _.filter(response.data, (d: any) => {
                        return !(_.findWhere(role.users, { id: d.id }));
                    });
                    this.employeeCategoryDetail = null;
                });
        }

        selectAll(): void {
            let role = this.castModel<Model.SecurityRole>();
            if (Model.Guard.isNothing(role))
                return;
            // add all available users to users
            _.forEach(role.availableUsers, (i) => role.users.push(i));
            role.availableUsers.splice(0);
        }

        unselectAllItemCopy(): void {
            let role = this.castModel<Model.SecurityRole>();
            if (Model.Guard.isNothing(role))
                return;
            // add users all to available users
            _.forEach(role.users, (i) => role.availableUsers.push(i));
            role.users.splice(0);
        };

        addSelected(items): void {
            let role = this.castModel<Model.SecurityRole>();
            if (Model.Guard.isNothing(role))
                return;
            // add selected available users to users
            _.forEach(items, i => {
                if (_.find(role.users, (u) => { return u.displayName === (<Model.DataDetail>i).displayName }) === undefined) {
                    role.users.push(i);
                    role.availableUsers.splice(role.availableUsers.indexOf(i), 1);
                }
            });
        };

        removeSelected(items): void {
            let role = this.castModel<Model.SecurityRole>();
            if (Model.Guard.isNothing(role))
                return;
            // add selected users to available users
            _.forEach(items, i => {
                if (_.find(role.availableUsers, (u) => { return u.displayName === (<Model.DataDetail>i).displayName }) === undefined) {
                    role.availableUsers.push(i);
                    role.users.splice(role.users.indexOf(i), 1);
                }
            });
        };


        getCanSecurityRoleCriteria(locationId: any,isForCoOnly:boolean,isChanged:boolean): any {
            let role = this.castModel<Model.SecurityRole>();
           

            if (isChanged && (role.assignableRoles.length > 0 || role.smartCenters.length > 0)) {
               role.assignableRoles = [];
               role.smartCenters = [];
            }
            if ((this.identityService.current().centralOfficeId == locationId || locationId == null) && isForCoOnly) {
                this.canAssingSecurityRole.includeActive = true;
                this.canAssingSecurityRole.coSearchType = Model.CoSearchType.CentralOffice;
                this.canAssingSecurityRole.coFilterByLocationId = null;
                this.canAssingSecurityRole.coSearchResultFilter = Model.CoSearchResultsFilter.All;
                this.canAssingSecurityRole.location = null;
                this.canAssingSecurityRole.isForCoOnly = true;

                this.smartCenterCriteria = this.canAssingSecurityRole;
                this.smartCenterCriteria.coSearchResultFilter = Model.CoSearchResultsFilter.LocationOwned;

           } else if (this.identityService.inCentralOfficeMode() && (this.identityService.current().centralOfficeId == locationId || locationId == null)) {

                this.canAssingSecurityRole.includeActive = true;
                this.canAssingSecurityRole.coSearchType = Model.CoSearchType.CentralOffice;
                this.canAssingSecurityRole.coFilterByLocationId=null;
                this.canAssingSecurityRole.coSearchResultFilter = Model.CoSearchResultsFilter.All;
                this.canAssingSecurityRole.location = null;
                this.canAssingSecurityRole.isForCoOnly = false;

                this.smartCenterCriteria = this.canAssingSecurityRole;
                this.smartCenterCriteria.coSearchResultFilter = Model.CoSearchResultsFilter.LocationOverrides;
                this.smartCenterCriteria.coBusinessTypeId = null;
            } else {
                this.canAssingSecurityRole = null;
                this.smartCenterCriteria = this.canAssingSecurityRole;
                this.smartCenterCriteria.IncludeSystemSmartCenters = true;
            }
            return this.canAssingSecurityRole;
        }

        get allowTakeOwnership(): boolean {
            return false;
        }

        get allowFullAccessFeatures(): boolean {
            let role = this.castModel<Model.SecurityRole>();
            if (Model.Guard.isSomething(role) && !role.requireFullAccessUser)
                return true;
            else if (this.identityService.current().fullAccess)
                return true;
            else
                return false;

        }

        get hideUsers(): boolean {
            // Hide users when in CO mode viewing a CO owned security role
            return this.verifySelectedSectionModel()
                && this.isApplicationModeCO
                && this.identityService.current().centralOfficeId === this.selectedSection.model.homeLocationId
                && this.isOwning;
        }

        isBusinessTypeRequiredLogic(): boolean {
            let role = this.castModel<Model.SecurityRole>();
            var required = (Model.Guard.isSomething(role) && !role.isForCoOnly)
                && (super.isBusinessTypeRequiredLogic() || this.isEditing);
            return required;
        }

        delete() {
            let role = this.castModel<Model.SecurityRole>();
            if (Model.Guard.isSomething(role) && role.requireFullAccessUser && !this.identityService.current().fullAccess) {
                this.modalService.alert("MESASGE_ACTION_REQUIRES_FULL_ACCESS", Components.Modal.ModalTranslationModes.Translate);
                return;
            }
            super.delete();
        }

        save(): angular.IPromise<any> {
            var role = <Model.SecurityRole>this.selectedSection.model;
            role.numberOfDaysBeforeBookingIsAllowed = role.numberOfDaysBeforeBookingIsAllowed ? 1 : 0;
            if (this.mode === Model.MaintenanceFormState.Adding && Meevo.Model.Guard.isSomething(this.copyFromSecurityRoleDetail)) {
                role.copyFromRoleId = this.copyFromSecurityRoleDetail.id;
            }

            // inherit security permissions if the user is in copying state
            if (this.mode === Model.MaintenanceFormState.Copying && this.itemId) {
                role.copyFromRoleId = this.itemId.toString();
            }

            // collect removed users
            role.removedUsers = _.difference(this.loadedUserList, role.users);
            return super.save().then(() => {
                this.loadAvailableUsers();
            });
        }

        postUpdate(model: any) {
            super.postUpdate(model);
            this.initializeHeader(model);
        }

        postCopy(): void {
            super.postCopy();
            let model = this.castModel<Model.SecurityRole>();
            model.users = [];
            this.loadAvailableUsers();
            model.displayName = undefined;
        }

        postDelete(): void {
            super.postDelete();
            this.loadAvailableUsers();
        }

        postUnDeleteDelete(): void {
            super.postDelete();
            this.loadAvailableUsers();
        }




       

    }
}